import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Account } from '../../api/models/account.model';
import type { RootState } from '../store';

interface AccountsState {
    selectedAccount: Account;
}

const initialState: AccountsState = {
    selectedAccount: {} as Account,
};

const accountSlice = createSlice({
    name: 'accounts',
    initialState,
    reducers: {
        setSelectedAccount: (state, action: PayloadAction<Account>) => {
            state.selectedAccount = action.payload;
        },
    },
});

export const {
    setSelectedAccount,
} = accountSlice.actions;

export const selectAccount = (state: RootState) => state.accounts.selectedAccount;

export default accountSlice.reducer;
